import React from 'react';
import milaSock from 'assets/images/mila-sock.jpg';
import milaSockWebp from 'assets/images/mila-sock.jpg?as=webp';
import LazyLoad from 'react-lazyload';
import loadable from '@loadable/component';

const FadeIn = loadable(() => import('../common/FadeIn'));

/**
 * @returns {JSX.Element}
 * @constructor
 */
const SockBlock = () => (
  <section className='sock-block'>
    <div className='container'>
      <h2 className='sock-block__title'>
        Put a sock
        {' '}
        🧦
        {' '}
        on it.
      </h2>
      <div className='sock-block__content'>
        <div className='sock-block__description'>
          <p>
            Want to extend your filter life even further? We gave Mila washable “socks” that work as a pre-filter to
            capture larger particles. They’re easy to wash and reuse with each new filter you get.
          </p>
        </div>
        <figure className='sock-block__image'>
          <LazyLoad>
            <FadeIn>
              <picture>
                <source srcSet={milaSockWebp} type='image/webp' />
                <source srcSet={milaSock} type='image/jpg' />
                <img src={milaSock} alt='mila-sock' />
              </picture>
            </FadeIn>
          </LazyLoad>
        </figure>
        <a href='/buy/filters' className='btn btn--large'>Order Now</a>
      </div>
    </div>
  </section>
);

export default SockBlock;
